import * as React from "react";

import { Helmet } from "react-helmet";

export const Head = ({
  title: title,
  description,
  slug,
  norobots,
}: {
  title: string;
  description: string;
  slug?: string;
  norobots?: boolean;
}) => (
  <Helmet>
    <html lang="en" />
    <title>{title}</title>
    {norobots ? <meta name="robots" content="noindex" /> : null}
    <meta name="description" content={description} />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
    <link
      href="https://fonts.googleapis.com/css2?family=Inter:wght@300;700;800&display=swap"
      rel="stylesheet"
    />
    <link rel="apple-touch-icon" sizes="57x57" href="/apple-icon-57x57.png" />
    <link rel="apple-touch-icon" sizes="60x60" href="/apple-icon-60x60.png" />
    <link rel="apple-touch-icon" sizes="72x72" href="/apple-icon-72x72.png" />
    <link rel="apple-touch-icon" sizes="76x76" href="/apple-icon-76x76.png" />
    <link
      rel="apple-touch-icon"
      sizes="114x114"
      href="/apple-icon-114x114.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="120x120"
      href="/apple-icon-120x120.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="144x144"
      href="/apple-icon-144x144.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="152x152"
      href="/apple-icon-152x152.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="180x180"
      href="/apple-icon-180x180.png"
    />
    <link
      rel="icon"
      type="image/png"
      sizes="192x192"
      href="/android-icon-192x192.png"
    />
    <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
    <link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png" />
    <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
    <link rel="manifest" href="/manifest.json" />
    <meta name="msapplication-TileColor" content="#ffffff" />
    <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
    <meta name="theme-color" content="#ffffff"></meta>
    <noscript>
      {`
        <img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=532426739028661&ev=PageView&noscript=1"
        />
      `}
    </noscript>
    {slug === "thank-you" ? null : <script async src="/js/fb-pixel.js" />}
    <script
      async
      src="https://www.googletagmanager.com/gtag/js?id=AW-574951261"
    ></script>
    <script async src="/js/gtag.js"></script>
    <script
      async
      src="https://www.googletagmanager.com/gtag/js?id=UA-151920750-1"
    ></script>
    <script async src="/js/ga.js"></script>
    <script
      defer
      type="text/javascript"
      src="//cdn.callrail.com/companies/301993935/cac73cfd92356471246f/12/swap.js"
    ></script>
  </Helmet>
);
